<template>
  <v-card flat :class="viewMode === 'card' ? 'my-5' : ''" style="width: 100%">
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="primary"
      rounded
      height="6"
    ></v-progress-linear>

    <v-card-title class="pa-0 shadow-1">
      <v-img
        :src="require('@/assets/illustrations/bg_modal_card.svg')"
        cover
        position="left bottom"
        class="align-center"
        height="65px"
      >
        <v-card-title class="font-weight-medium primary--text">
          {{ titleMode }} Prueba
        </v-card-title>
      </v-img>
    </v-card-title>

    <v-card-text>
      <v-stepper v-model="stepProcess">
        <v-stepper-header>
          <v-stepper-step :complete="stepProcess > 1" step="1">
            Seleccionar Opciones
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="stepProcess > 2" step="2">
            Preguntas
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step step="3"> Resumen </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <!-- OPTIONS -->
          <v-stepper-content step="1">
            <ValidationObserver ref="formOptions">
              <v-card-text style="max-height: 450px">
                <v-form>
                  <v-row dense>
                    <!-- Cola -->
                    <v-col cols="3">
                      <v-select
                        v-model="queueToFilter"
                        @input="getFilteredAgentsList"
                        prepend-inner-icon="mdi-tray-full"
                        required
                        filled
                        rounded
                        dense
                        class="rounded-small"
                        item-text="name"
                        item-value="id"
                        :items="queueList"
                        label="Cola"
                      ></v-select>
                    </v-col>
                    <!-- Agente -->
                    <v-col cols="6">
                      <ValidationProvider
                        ref="agent"
                        name="Seleccionar Agente"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-autocomplete
                          v-model="agentSelected"
                          :items="filteredAgentsList"
                          :error-messages="errors"
                          item-text="name"
                          item-value="id"
                          :loading="isLoadingAgents"
                          prepend-inner-icon="mdi-account"
                          class="rounded-small"
                          label="Seleccionar Agente"
                          required
                          filled
                          rounded
                          dense
                          @input="getFilteredAgentExtensionList"
                        ></v-autocomplete>
                      </ValidationProvider>
                    </v-col>

                    <!-- Extensión -->
                    <v-col cols="3">
                      <v-select
                        v-model="extensionSelected"
                        prepend-inner-icon="mdi-tray-full"
                        required
                        filled
                        rounded
                        dense
                        class="rounded-small"
                        :items="filteredAgentExtensionList"
                        label="Extensión"
                      ></v-select>
                    </v-col>
                    <!-- Fecha -->
                    <v-col cols="6">
                      <ValidationProvider
                        ref="date"
                        name="Seleccionar Fecha"
                        v-slot="{ errors }"
                      >
                        <v-menu
                          v-model="dateMenu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              filled
                              :error-messages="errors"
                              rounded
                              label="Fecha"
                              class="rounded-small"
                              prepend-inner-icon="mdi-calendar-today"
                              readonly
                              :value="dateToPicker"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            locale="en-in"
                            v-model="dateToPicker"
                            no-title
                            @input="dateMenu = false"
                          ></v-date-picker>
                        </v-menu>
                      </ValidationProvider>
                    </v-col>
                    <!-- Hora -->
                    <v-col cols="3">
                      <ValidationProvider
                        ref="date"
                        name="Seleccionar Hora"
                        v-slot="{ errors }"
                      >
                        <v-menu
                          ref="hourMenu"
                          v-model="isHourMenuOpen"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          max-width="580px"
                          min-width="290px"
                          class="d-flex"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              label="Hora"
                              prepend-inner-icon="mdi-clock-time-four-outline"
                              readonly
                              class="rounded-small"
                              v-bind="attrs"
                              v-on="on"
                              :value="`${hourStartSelected || ''} - ${
                                hourEndSelected || ''
                              }`"
                              :error-messages="errors"
                              filled
                              rounded
                            ></v-text-field>
                          </template>
                          <v-time-picker
                            v-if="isHourMenuOpen"
                            v-model="hourStartSelected"
                            @change="hourEndSelected = null"
                            format="24hr"
                          ></v-time-picker>
                          <v-time-picker
                            v-if="isHourMenuOpen"
                            v-model="hourEndSelected"
                            :min="hourStartSelected || null"
                            @click:minute="$refs.hourMenu.save()"
                            format="24hr"
                          ></v-time-picker>
                        </v-menu>
                      </ValidationProvider>
                    </v-col>
                    <!-- Telefono -->
                    <v-col cols="3">
                      <ValidationProvider
                        ref="phone"
                        name="Telefono"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          filled
                          :error-messages="errors"
                          rounded
                          label="Telefono"
                          class="rounded-small"
                          prepend-inner-icon="mdi-phone"
                          v-model="phone"
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <!-- Grabacion -->
                    <v-col cols="12">
                      <ValidationProvider
                        ref="recording"
                        name="Seleccionar Grabación"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          filled
                          :error-messages="errors"
                          rounded
                          label="Grabación"
                          class="rounded-small"
                          prepend-inner-icon="mdi-play"
                          readonly
                          :value="
                            recordingSelected ? recordingSelected.fecha : ''
                          "
                          @click="showRecordingsDialog"
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <!-- Grabacion externa -->
                    <v-col cols="12" v-if="recordingSelected === null">
                      <ValidationProvider
                        ref="externalRecording"
                        name="colocar URL Grabación externa"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          filled
                          :error-messages="errors"
                          rounded
                          label="URL Grabación externa"
                          class="rounded-small"
                          prepend-inner-icon="mdi-play"
                          v-model="ExternalRecording"
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <!-- Evaluacion -->
                    <v-col cols="12">
                      <ValidationProvider
                        ref="evaluation"
                        name="Evaluacion"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-select
                          :error-messages="errors"
                          prepend-inner-icon="mdi-file"
                          required
                          filled
                          rounded
                          dense
                          class="rounded-small"
                          :items="EvaluationList"
                          item-text="name"
                          item-value="id"
                          label="Evaluacion"
                          v-model="evaluationSelected"
                        ></v-select>
                      </ValidationProvider>
                    </v-col>
                    <!-- Observaciones -->
                    <v-col cols="12">
                      <ValidationProvider
                        name="Observaciones"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          filled
                          rounded
                          class="rounded-small"
                          dense
                          label="Observaciones"
                          name="value"
                          prepend-inner-icon="mdi-format-align-justify"
                          type="text"
                          color="blue-grey"
                          v-model="observations"
                          :error-messages="errors"
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
            </ValidationObserver>
          </v-stepper-content>
          <!-- QUESTIONS -->
          <v-stepper-content step="2">
            <ValidationObserver ref="obs">
              <v-row>
                <v-col cols="12" class="pb-0">
                  <v-btn
                    v-if="showReadChat"
                    rounded
                    color="info"
                    @click="openReadChat = true"
                    small
                  >
                    Leer Chat</v-btn
                  >
                </v-col>
                <!-- Main grabacion -->
                <v-col cols="12" class="pa-0">
                  <div class="py-0 px-3 d-flex" v-if="recordingSelected">
                    <p class="mb-0 mr-3">
                      <span class="info--text">Origen:</span>
                      {{ testBody.origin }}
                    </p>
                    <p class="mb-0 mr-3">
                      <span class="info--text">Destino:</span>
                      {{ testBody.destination }}
                    </p>
                    <p class="mb-0 mr-3">
                      <span class="info--text">Duracion:</span>
                      {{ testBody.duration | secondsToTimeFormat }}
                    </p>
                  </div>
                  <div class="pa-0 d-flex pt-3">
                    <!-- <v-icon>mdi-play</v-icon> -->
                    <audio
                      v-if="ExternalRecording !== null"
                      src="ExternalRecording"
                      controls
                      class="d-block"
                      ref="audioPlayer"
                      style="height: 30px"
                    >
                      <p>Tu navegador no implementa el elemento audio.</p>
                    </audio>
                    <audio
                      v-else-if="testBody.recordings"
                      controls
                      class="d-block"
                      ref="audioPlayer"
                      style="height: 30px"
                    >
                      <source
                        :src="
                          'https://' +
                          recordingSelectedUrl +
                          recordingPathGenerator(testBody.recordings)
                        "
                        type="audio/wav"
                      />

                      <source
                        :src="
                          'https://' +
                          recordingSelectedUrl +
                          recordingPathGenerator(testBody.recordings, true)
                        "
                        type="audio/mpeg"
                      />
                      <p>Tu navegador no implementa el elemento audio.</p>
                    </audio>
                  </div>
                  <!-- <span class="caption grey--text" v-else>No disponible</span> -->
                </v-col>
                <v-col v-if="!recordingAdditionalSelected" cols="12">
                  No es lo que esperabas?
                  <v-btn
                    text
                    @click="showRecordingsDialog"
                    color="primary"
                    class="text-lowercase pa-0"
                    style="height: 21px"
                  >
                    elije otra grabacion.
                  </v-btn>
                </v-col>
                <!-- Additional grabacion -->
                <v-col
                  v-if="recordingAdditionalSelected"
                  cols="12"
                  class="pa-0 pt-2"
                >
                  <div class="py-0 px-3 d-flex">
                    <p class="mb-0 mr-3">
                      <span class="info--text">Origen:</span>
                      {{ recordingAdditionalSelected.src }}
                    </p>
                    <p class="mb-0 mr-3">
                      <span class="info--text">Destino:</span>
                      {{ recordingAdditionalSelected.dst }}
                    </p>
                    <p class="mb-0 mr-3">
                      <span class="info--text">Duracion:</span>
                      {{
                        String(recordingAdditionalSelected.duracion)
                          | secondsToTimeFormat
                      }}
                    </p>
                  </div>
                  <div class="pa-0 d-flex pt-3">
                    <!-- <v-icon>mdi-play</v-icon> -->
                    <audio
                      :src="`http://${recordingAdditionalUrl}${recordingAdditionalSelected.recordings}`"
                      controls
                      class="d-block"
                      ref="secondAudioPlayer"
                      style="height: 30px"
                    >
                      <source
                        :src="
                          'https://' +
                          recordingAdditionalUrl +
                          recordingPathGenerator(
                            recordingAdditionalSelected.recordings
                          )
                        "
                        type="audio/wav"
                      />

                      <source
                        :src="
                          'https://' +
                          recordingAdditionalUrl +
                          recordingPathGenerator(
                            recordingAdditionalSelected.recordings,
                            true
                          )
                        "
                        type="audio/mpeg"
                      />
                      <p>Tu navegador no implementa el elemento audio.</p>
                    </audio>
                  </div>
                  <!-- <span class="caption grey--text" v-else>No disponible</span> -->
                </v-col>

                <v-col cols="12" md="6">
                  <v-card-text
                    v-if="isEditingEvaluation"
                    class="py-0 d-flex mt-1"
                  >
                    <v-select
                      prepend-inner-icon="mdi-file"
                      required
                      filled
                      rounded
                      dense
                      class="rounded-small"
                      :items="EvaluationList"
                      item-text="name"
                      item-value="id"
                      label="Evaluacion"
                      v-model="evaluationSelected"
                      @change="getQuestions"
                    ></v-select>
                  </v-card-text>
                  <v-card-text v-else class="py-0 d-flex mt-0">
                    <p class="mb-0 pb-1 pt-1">
                      Evaluación: {{ EvaluationSelectedName }}
                    </p>
                    <v-btn
                      color="primary"
                      style="margin-top: 1px"
                      @click="isEditingEvaluation = true"
                      small
                      text
                    >
                      Cambiar
                    </v-btn>
                  </v-card-text>
                  <ValidationProvider
                    name="Estatus de la prueba"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-radio-group
                      v-model="approvedStatus"
                      row
                      class="mt-0 pl-3"
                      :error-messages="errors"
                    >
                      <v-radio label="Aprobado" :value="1"></v-radio>
                      <v-radio label="Reprobado" :value="0"></v-radio>
                    </v-radio-group>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="6" class="py-0 d-flex">
                  <v-card-text>
                    <v-text-field
                      filled
                      rounded
                      class="rounded-small"
                      dense
                      label="Observaciones"
                      name="value"
                      prepend-inner-icon="mdi-format-align-justify"
                      type="text"
                      color="blue-grey"
                      v-model="observations"
                    ></v-text-field>
                  </v-card-text>
                </v-col>
              </v-row>
              <vuescroll
                :ops="{
                  bar: { background: '#bacfcec0', keepShow: true },
                }"
              >
                <v-card-text v-if="isLoadingQuestions">
                  <v-skeleton-loader type="article"></v-skeleton-loader>
                </v-card-text>
                <v-card-text v-else class="py-0" style="max-height: 350px">
                  <v-form>
                    <v-row dense>
                      <v-col cols="12">
                        <section v-for="(q, index) in questionList" :key="q.id">
                          <v-row>
                            <v-col cols="12" class="pt-0">
                              <v-card-text>
                                {{ index + 1 }}. {{ q.name }}
                              </v-card-text>
                              <v-card-text class="py-1">
                                <ValidationProvider
                                  :ref="JSON.stringify(q.id)"
                                  :name="`Pregunta ${index + 1}`"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-radio-group
                                    required
                                    :error-messages="errors"
                                    v-model="questionResponse[index].answer_id"
                                    row
                                  >
                                    <v-radio
                                      v-for="n in q.answer"
                                      :key="n.id"
                                      :label="n.name"
                                      :value="n.id"
                                    ></v-radio>
                                  </v-radio-group>
                                </ValidationProvider>
                              </v-card-text>
                            </v-col>
                            <v-col cols="12">
                              <v-card-text class="py-1">
                                <ValidationProvider
                                  name="Observaciones"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    filled
                                    rounded
                                    class="rounded-small"
                                    dense
                                    label="Observaciones"
                                    name="value"
                                    prepend-inner-icon="mdi-label-variant"
                                    type="text"
                                    color="blue-grey"
                                    v-model="
                                      questionResponse[index].observation
                                    "
                                    :error-messages="errors"
                                  ></v-text-field>
                                </ValidationProvider>
                              </v-card-text>
                            </v-col>
                          </v-row>
                        </section>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </vuescroll>
            </ValidationObserver>
          </v-stepper-content>
          <!-- OVERVIEW -->
          <v-stepper-content step="3">
            <vuescroll
              :ops="{
                bar: { background: '#bacfcec0', keepShow: true },
              }"
            >
              <v-card-text>
                <v-row>
                  <v-col cols="12" class="py-0">
                    <p class="mb-0">
                      <span class="info--text">Agente:</span>
                      {{ agentSelected }}
                    </p>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <p class="mb-0">
                      <span class="info--text"> Fecha:</span>
                      {{ testBody.date }}
                    </p>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <p class="mb-0">
                      <span class="info--text"> Evaluacion:</span>
                      {{ EvaluationSelectedName }}
                    </p>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <p class="mb-0">
                      <span class="info--text"> Observaciones:</span>
                      {{ observations || "Sin Observaciones" }}
                    </p>
                  </v-col>
                  <template v-if="recordingSelected">
                    <v-col cols="12" class="py-0">
                      <v-card-title
                        class="pb-0 pl-0 pt-0 my-2 text-body-2 font-weight-bold"
                      >
                        Grabación:
                      </v-card-title>
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <p class="mb-0">
                        <span class="info--text">Origen:</span>
                        {{ testBody.origin }}
                      </p>
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <p class="mb-0">
                        <span class="info--text">Destino:</span>
                        {{ testBody.destination }}
                      </p>
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <p class="mb-0">
                        <span class="info--text">Duracion:</span>
                        {{ testBody.duration | secondsToTimeFormat }}
                      </p>
                    </v-col>
                  </template>
                </v-row>
                <!-- Questions -->
                <v-row>
                  <v-col cols="5" class="pb-0">
                    <v-card-title class="pb-0"> Preguntas </v-card-title>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
                <v-row v-for="(res, index) in questionResponse" :key="index">
                  <v-col cols="12" class="py-0">
                    <v-card-text
                      class="pb-0 primary--text"
                      style="font-size: 16px"
                    >
                      {{ index + 1 }}.
                      {{
                        questionList.find((q) => q.id === res.question_id).name
                      }}
                    </v-card-text>
                    <p class="my-2 pl-8">
                      {{ findAnswer(res.question_id, res.answer_id) }}
                    </p>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <v-card-text
                      class="ml-4 py-0 primary--text"
                      style="font-size: 16px"
                      >Observacion:</v-card-text
                    >
                    <p class="my-2 pl-8">
                      {{ res.observation || "Sin observaciones" }}
                    </p>
                  </v-col>
                </v-row>
              </v-card-text>
            </vuescroll>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card-text>

    <v-divider></v-divider>
    <v-card-text v-if="totalValue !== 100 && errorStep2.length > 0">
      {{ errorStep2 }}
    </v-card-text>
    <v-card-actions class="mx-2">
      <v-hover v-slot:default="{ hover }">
        <v-btn
          text
          rounded
          class="mr-1"
          :color="hover ? 'error' : 'grey'"
          @click="closeDialog"
        >
          Cancelar
        </v-btn>
      </v-hover>

      <v-spacer></v-spacer>
      <v-progress-circular
        v-if="stepProcess === 2"
        :rotate="-90"
        :size="40"
        :width="5"
        :value="totalValue.toFixed(2)"
        color="primary"
      >
        {{ totalValue }}
      </v-progress-circular>
      <v-hover v-if="stepProcess > 1">
        <v-btn
          rounded
          text
          :loading="loading"
          :disabled="loading"
          color="grey"
          class="px-8"
          @click.stop="backButton()"
          >Atras
        </v-btn>
      </v-hover>
      <v-hover v-slot:default="{ hover }">
        <v-btn
          rounded
          :loading="loading"
          :disabled="loading"
          color="success"
          :class="hover ? 'shadow-2' : 'shadow-4'"
          class="px-8"
          @click.stop="submitForm()"
        >
          {{
            stepProcess === 3
              ? this.mode === "edit"
                ? "Actualizar"
                : "Añadir"
              : "Siguiente"
          }}
        </v-btn>
      </v-hover>
    </v-card-actions>
    <recordings-dialog
      v-if="isOpenRecordingsDialog"
      :dateStart="`${dateToPicker} ${hourStartSelected}:00`"
      :dateEnd="`${dateToPicker} ${hourEndSelected}:00`"
      :extension="
        filteredAgentsList.find(({ id }) => id === agentSelected).extension ||
        ''
      "
      :queue="queueSelected"
      :phone="phone"
      :recordingsDialog="isOpenRecordingsDialog"
      @dialog:close="recordingSelection"
    ></recordings-dialog>

    <message-dialog
      v-if="dataToForm && dataToForm.ticket_id"
      :open="openReadChat"
      :ticket="{ id: dataToForm.ticket_id }"
      @dialog:close="openReadChat = false"
    >
    </message-dialog>
  </v-card>
</template>

<script>
import axios from "axios";
import vuescroll from "vuescroll";
import moment from "moment";
import { PbxHttpClient } from "@/services/httpclient";
import RecordingsDialog from "./RecordingsDialog.vue";
import MessageDialog from "../CDR/Whatsapp/MessageDialog.vue";
import recordingPathGenerator from "../Utils/recordingPathGenerator";

export default {
  props: {
    viewMode: {
      type: String,
      default: "card",
    },
    mode: {
      type: String,
      default: "register",
    },
    dataToForm: {
      type: Object,
    },
    idEvaluation: {
      type: Number,
    },
  },
  components: { vuescroll, RecordingsDialog, MessageDialog },
  data() {
    return {
      // Recordings
      isOpenRecordingsDialog: false,
      loading: false,
      isLoadingQuestions: false,
      isEditingEvaluation: false,
      recordingPathGenerator: recordingPathGenerator,
      //Stepper
      stepProcess: 1,
      errorStep2: "",
      //Test Selects
      agentList: [],
      agentSelected: null,
      evaluationSelected: null,
      observations: null,
      phone: "",
      // recordingUrl: "",
      // recordingQueueUrl: "",
      recordingSelected: null,
      recordingSelectedUrl: null,
      recordingAdditionalSelected: null,
      recordingAdditionalUrl: null,
      ExternalRecording: null,
      recordMenu: false,
      //Questions
      questionList: [],
      questionResponse: [],
      questionValue: [],
      //Date Picker
      dateMenu: false,
      dateToPicker: moment().format("YYYY-MM-DD"),
      queueToFilter: null,
      debounceAgentsList: null,
      filteredAgentsList: [],
      filteredAgentExtensionList: [],
      isLoadingAgents: false,
      queueList: [
        {
          name: "Todas",
          id: null,
          number: null,
          client_id: null,
        },
      ],
      hourStartSelected: "01:00",
      hourEndSelected: "23:00",
      isHourMenuOpen: false,
      approvedStatus: null,
      showReadChat: false,
      openReadChat: false,
    };
  },
  created() {
    this.getFilteredAgentsList();
    this.getEvaluations();
    this.getQueues();
    if (this.mode === "edit") {
      this.observations = this.dataToForm.observations;
      this.dateToPicker = moment(this.dataToForm.date).format("YYYY-MM-DD");
      this.observations = this.dataToForm.observations;
      this.dateToPicker = moment(this.dataToForm.date).format("YYYY-MM-DD");
      this.agentSelected = this.dataToForm.user_id;
      this.extensionSelected = this.dataToForm.ext;
      this.recordingSelected = this.dataToForm.recordings;
      this.recordingSelectedUrl = this.dataToForm.recordingSelectedUrl;
      this.evaluationSelected = this.dataToForm.evaluation_id;
      this.approvedStatus = this.dataToForm.approved_status;
      this.getQuestions();
    }
    if (this.mode === "from-audit") {
      this.observations = this.dataToForm.observations;
      this.dateToPicker = moment(this.dataToForm.date).format("YYYY-MM-DD");
      this.observations = this.dataToForm.observations;
      this.dateToPicker = moment(this.dataToForm.date).format("YYYY-MM-DD");
      this.agentSelected = this.dataToForm.user_id;
      this.extensionSelected = this.dataToForm.ext;
      this.queueToFilter = this.dataToForm.queue_id;
      this.recordingSelected = this.dataToForm.recordings;
      this.recordingSelectedUrl = this.dataToForm.recordingSelectedUrl;
      this.evaluationSelected = this.dataToForm.evaluation_id;
      this.showReadChat = this.dataToForm.isWhatsapp;
      this.getQuestions();
      this.stepProcess = 2;
    }
  },
  computed: {
    EvaluationSelectedName() {
      return this.EvaluationList.find((el) => el.id === this.evaluationSelected)
        ?.name;
    },
    EvaluationList() {
      return this.$store.getters["evaluations/GET_ALL_EVALUATIONS"];
    },
    testBody() {
      return this.mode === "from-audit"
        ? {
            evaluation_id: this.evaluationSelected,
            date: moment(this.dateToPicker).format("YYYY/MM/DD"),
            recordings: this.recordingPathGenerator(
              this.recordingSelected?.recordingfile || ""
            ),
            origin: this.recordingSelected?.src,
            destination: this.recordingSelected?.dst,
            duration: String(this.recordingSelected?.duracion),
            observations: this.observations,
            user_id: this.agentSelected,
            extension: this.extensionSelected,
            recording_home: this.ExternalRecording,
          }
        : {
            evaluation_id: this.evaluationSelected,
            date: moment(this.dateToPicker).format("YYYY/MM/DD"),
            recordings: this.recordingPathGenerator(
              this.recordingSelected?.recordingfile || ""
            ),
            origin: this.recordingSelected?.src,
            destination: this.recordingSelected?.dst,
            duration: String(this.recordingSelected?.duracion),
            observations: this.observations,
            user_id: this.agentSelected,
            extension: this.extensionSelected,
            recording_home: this.ExternalRecording,
          };
    },

    totalValue() {
      const answersValue = this.questionResponse.map((q, index) => {
        if (q.answer_id !== null) {
          const value = this.questionList[index].answer.find(
            (ans) => ans.id === q.answer_id
          ).value;
          return (value * this.questionValue[index]) / 100;
        } else return null;
      });

      return answersValue.reduce(
        (prev, next) => (next !== null ? prev + next : prev),
        0
      );
    },

    titleMode() {
      return this.mode === "register" ? "Nuevo" : "Editar";
    },
  },

  watch: {
    agentSelected() {
      if (this.mode !== "from-audit") this.recordingSelected = null;
    },
    dateToPicker() {
      if (this.mode !== "from-audit") this.recordingSelected = null;
    },
  },

  methods: {
    recordingSelection({ url, item }) {
      if (item) {
        if (this.stepProcess === 1) {
          this.recordingSelected = item;
          this.recordingSelectedUrl = url;
        }
        if (this.stepProcess === 2) {
          this.recordingAdditionalSelected = item;
          this.recordingAdditionalUrl = url;
        }

        setTimeout(() => {
          this.$refs.secondAudioPlayer.style.width = "100%";
        }, 300);
      }

      this.isOpenRecordingsDialog = false;
    },
    closeDialog(reloadList = false) {
      //console.log("closing dialog...")
      this.$emit("processFormDialog:close", reloadList);
    },
    showRecordingsDialog() {
      this.isOpenRecordingsDialog = true;
    },
    /**
     * @param question_id {Number}
     * @param answer_id {Number}
     */
    findAnswer(question_id, answer_id) {
      const answer = this.questionList
        .find((q) => q.id === question_id)
        .answer.find((ans) => ans.id === answer_id);
      return answer ? answer.name : null;
    },
    //Store
    async submitForm() {
      if (this.stepProcess !== 3) {
        if (this.stepProcess === 1) {
          const isValid = await this.$refs.formOptions.validate();
          // if(!agentSelected) {this.$refs['agent'].validate();return}
          // if (!this.evaluationSelected) {
          //   this.$refs["evaluation"].validate();
          //   return;
          // }
          if (isValid) this.getQuestions();
          else return;
        }
        if (this.stepProcess === 2) {
          const isValid = await this.$refs.obs.validate();
          if (!isValid) {
            this.errorStep2 =
              "Debe contestar todas las preguntas antes de continuar";
            return;
          }
        }

        // console.log(this.$refs.audioPlayer)
        this.stepProcess += 1;
        // setImmediate(()=>this.$refs.audioPlayer.style.width = "100%" )
        setTimeout(() => {
          this.$refs.audioPlayer.style.width = "100%";
          this.$refs.secondAudioPlayer.style.width = "100%";
        }, 300);
        return;
      }
      const payload = {
        ...this.testBody,
        value: this.totalValue,
        approved_status: this.approvedStatus,
        response: this.questionResponse,
      };
      this.loading = true;

      if (this.mode === "from-audit")
        payload.audit_id = this.dataToForm.audit_id;

      if (this.mode === "edit") {
        await this.$store.dispatch("tests/EDIT_TEST_QUESTION", {
          ...payload,
          id: this.dataToForm.id,
        });
        this.$snotify.success("Prueba actualizada con éxito.", "¡Hecho!");
        this.closeDialog(true);
        return;
      }

      const response = await this.$store.dispatch(
        "tests/REGISTER_TEST",
        payload
      );
      this.loading = false;
      if (response === 422) {
        this.$snotify.error(
          "La valor de la evaluacion es menor a 100%",
          "Error"
        );
        return;
      }
      if (response?.message === "Network Error") {
        this.$snotify.error("Hubo un error guardando la prueba", "Error");
        return;
      }
      if (this.mode === "from-audit") this.closeDialog();
      this.$snotify.success("Prueba creada con éxito.", "¡Hecho!");
      this.resetForm();
      // this.closeDialog();
    },
    async getCategories() {
      try {
        await this.$store.dispatch("categories/SHOW_CATEGORIES");
      } catch (error) {
        console.log(error);
      }
    },
    async getEvaluations() {
      try {
        await this.$store.dispatch("evaluations/SHOW_ALL_EVALUATIONS");
      } catch (error) {
        console.log(error);
      }
    },
    async getQuestions() {
      const id = this.evaluationSelected;

      this.isEditingEvaluation = false;
      this.isLoadingQuestions = true;
      try {
        const response = await this.$store.dispatch("process/SHOW_PROCESS", id);
        const Authorization = `Bearer ${localStorage.getItem("token")}`;
        const processIds = response.map((p) => p.question_id);
        const questions = [];
        for (const id of processIds) {
          const question = await axios.get(
            `${process.env.VUE_APP_ROOTAPI}/quality/questions/${id}`,
            { headers: { Authorization } }
          );
          questions.push(question.data.data);
        }
        this.questionList = questions;
        this.questionValue = response.map((process) => process.value);
        this.questionResponse = questions.map((q) => {
          const answerByQuestion =
            this.mode === "edit"
              ? this.dataToForm.test_response.find(
                  (res) => res.question_id === q.id
                )
              : null;

          return {
            question_id: q.id,
            answer_id: answerByQuestion?.answer_id || null,
            observation: answerByQuestion?.observation || null,
          };
        });
      } catch (error) {
        console.log(error);
      }
      this.isLoadingQuestions = false;
    },

    async getQueues() {
      try {
        const { data } = await PbxHttpClient.get("/clients/listQueue");
        // this.filteredAgentsList = data.data
        this.queueList = [
          ...this.queueList,
          ...data.data.map((el) => ({
            ...el,
            name: `${el.name} - ${el.number}`,
          })),
        ];
        // console.log("all queues:", data);
      } catch (err) {
        console.log("error getting queue", err);
      }
    },
    resetForm() {
      this.agentSelected = null;
      this.errorStep2 = "";
      this.observations = null;
      this.evaluationSelected = null;
      this.questionList = [];
      this.questionResponse = [];
      this.questionValue = [];
      this.recordingSelected = null;
      if (this.mode !== "edit") this.$refs.formOptions.reset();
      this.stepProcess = 1;
      this.closeDialog(true);
    },
    async getFilteredAgentsList() {
      this.isLoadingAgents = true;
      this.filteredAgentExtensionList = [];
      this.extensionSelected = "";
      try {
        clearTimeout(this.debounceAgentsList);
        const queue_id = this.queueToFilter;

        if (queue_id) {
          const queueObject = this.queueList.find(
            (item) => item.id === queue_id
          );
          this.queueSelected = queueObject.number;
        }

        this.debounceAgentsList = setTimeout(async () => {
          const { data } = queue_id
            ? await PbxHttpClient.get("/clients/show/agents_select", {
                params: { queue_id },
              })
            : await PbxHttpClient.get("/clients/show/agents_select");
          this.filteredAgentsList = data.data;

          if (this.agentSelected) this.getFilteredAgentExtensionList();
          // console.log("all agents:", data)
          this.isLoadingAgents = false;
        }, 1000);
      } catch (err) {
        console.log("error getting agents", err);
        this.isLoadingAgents = false;
      }
    },

    getFilteredAgentExtensionList() {
      this.filteredAgentExtensionList = [];
      this.extensionSelected = "";
      const agent = this.filteredAgentsList.find(
        (item) => item.id == this.agentSelected
      );

      if (agent.extesion !== null) {
        this.filteredAgentExtensionList.push(agent.extension);
        this.extensionSelected = agent.extension;
      }

      agent.extension_opcional != null
        ? this.filteredAgentExtensionList.push(agent.extension_opcional)
        : "";
    },

    //Stepper
    backButton() {
      this.stepProcess -= 1;
    },
  },
};
</script>
